import $ from "jquery";
import "jquery-mask-plugin";
import { dataaccess } from "../dataaccess/dataContext";
import { services } from "../services/notificationService";
import { course } from "../modules/course";
const css = {
    "background-color": "#E91F00",
    "border-color": "#E91F00",
    "box-shadow": "#E91F00 0 0 0 8px inset"
};

function init() {
    $("#quantity")
        .val("")
        .mask("S#", {
            translation: {
                S: {
                    pattern: /-/,
                    optional: true
                }
            }
        });

    processLmsButtons();
    setEvents();
}

function setEvents() {
    $(document).on("click", "#studentTable .dropdown-menu, #facultyTable .dropdown-menu", function (
        e
    ) {
        e.stopPropagation();
    });

    $(document).on(
        "dblclick",
        "#studentTable .dropdown-menu, #facultyTable .dropdown-menu",
        function (e) {
            e.stopPropagation();
        }
    );


    $(document).on("click", ".js-lms-button", function (e) {
        const $control = $(this);
        const licenseType = $control.attr("data-licensetype");
        const isAssigned = $control.attr("data-isassigned");
        if (licenseType !== "X") {
            if (isAssigned === "True") {
                return;
            }

            $control.next("span").css(css);
            $control
                .closest("div")
                .next(".processing")
                .show();

            dataaccess
                .post({
                    url:
                        "/EthosBank/Add" +
                        "/Passtype/" + licenseType +
                        "/Course/" + $("#courseId").val() +
                        "/Roster/" + $control.closest("tr").attr("data-personId")
                })
                .fail(function (xhr, status, error) {
                    if (xhr.responseText !== "") {
                        services.notificationService.info(xhr.responseText);
                    }
                    $control.next("span").removeAttr("style");
                    $control
                        .closest("div")
                        .next(".processing")
                        .hide();
                    course.populateStudentTable();
                })
                .done(function () {
                    $control.next("span").removeAttr("style");
                    $control
                        .closest("div")
                        .next(".processing")
                        .hide();
                    course.populateStudentTable();
                    processLmsButtons();
                });
        } else {
            if (isAssigned === "False") {
                return;
            }

            $control.next("span").css(css);
            $control
                .closest("div")
                .next(".processing")
                .show();

           dataaccess
                .get({
                    url:
                        "/EthosBank/OpenConfirmRemoveModal/Course/" +
                        $("#courseId").val() +
                        "/Roster/" +
                        $control.attr("data-personid")
                })
                .done(function (res) {
                    $("#ConfirmRemoveEthosAccess")
                        .find(".modal-content")
                        .html(res);
                });
            $("#ConfirmRemoveEthosAccess").modal("show");
        }
    });

    $(document).on("click", "#confirm-remove-ethos", function () {
        const personId = $(this).attr("data-personId");
        const $control = $(this);
        dataaccess
            .post({
                url: "/EthosBank/Remove/Course/" + $("#courseId").val() + "/Roster/" + personId
            })
            .done(function () {
                course.populateStudentTable();
            })
            .fail(function (xhr, status, error) {
                if (xhr.responseText !== "") {
                    services.notificationService.info(xhr.responseText);
                }
                course.populateStudentTable();
            });
    });

}

function renderEthosBank() {
    if ($("#courseEthosBankContainer").length > 0) {
        dataaccess
            .get({ url: "/EthosBank/Course/" + $("#courseId").val() })
            .done(function (result) {
                $("#courseEthosBankContainer").html(result);
                processLmsButtons();
            });
    }
}

function processLmsButtons() {
    const individualPassesAvailable = getIndividualPassesAvailable();
    const sitePassesAvailable = getSitePassesAvailable();
    let isAssigned = "";
    $(".js-lms-button").each(function () {
        isAssigned = $(this).attr("data-isassigned");
        if ($(this).attr("data-licensetype") === "X" ) {
            return;
        }
        $(this).attr("disabled", "disabled");

        if ($(this).attr("data-licenseType") === "I") {
            if (individualPassesAvailable > 0 && isAssigned === "False") {
                $(this).removeAttr("disabled");
            }
            if ($(this).attr("data-licenseType") === $(this).attr("data-assignedlicensetype")) {
                $(this).addClass("btn-enrolled");
            }

        }
        if ($(this).attr("data-licenseType") === "S") {
            if (sitePassesAvailable > 0 && isAssigned === "False") {
                $(this).removeAttr("disabled");
            }
            if ($(this).attr("data-licenseType") === $(this).attr("data-assignedlicensetype")) {
                $(this).addClass("btn-enrolled");
            }
        }
    });
}

function getIndividualPassesAvailable() {
    return parseInt($("#individualCount").val());
}

function getSitePassesAvailable() {
    return parseInt($("#siteCount").val());

}

export const ethosBank = {
    init: init,
    renderEthosBank: renderEthosBank
};
